import type { HelloBarPropsApi } from '../models'

export interface HelloBarStorageData {
    id: number
    startDate: Date
    endDate: Date
}

export const getUpdatedStorageData = (
    helloBarStorageData: HelloBarStorageData[] | undefined,
    pageHelloBar: HelloBarPropsApi,
    helloBarId: number
): HelloBarStorageData[] | undefined => {
    const helloBarStorageDataArray = helloBarStorageData || []

    const createHelloBarStorageData = (newHelloBarId: number) => {
        const startDateTime = pageHelloBar.startTime
        const endDateTime = pageHelloBar.endTime
        return {
            id: newHelloBarId,
            startDate: startDateTime,
            endDate: endDateTime,
        }
    }

    let helloBarRecordExists = false

    const updatedStorageData = helloBarStorageDataArray.map((helloBar: HelloBarStorageData) => {
        if (helloBar.id === helloBarId) {
            helloBarRecordExists = true
            return createHelloBarStorageData(helloBarId)
        }
        return helloBar
    })

    if (helloBarRecordExists) return [...updatedStorageData]

    return [...updatedStorageData, createHelloBarStorageData(helloBarId)]
}

export default getUpdatedStorageData
